"use client";

import { ColumnDef } from "@tanstack/react-table";
import CommonList from "@/components/common/List";
import CommonTableList from "@/components/common/TableList";
import UserCreate from "./Create";
import UserEdit from "./Edit";
import { FC } from "react";
import { User } from "@/interface/entityInterface";
import { tableCol } from "@/components/common/columns/columns";
import { useSipContext } from "../../context/SipContext";

interface Props {
  costumCols?: any;
  roles: {label: string, value: string}[]
}

const UsersList: FC<Props> = ({ costumCols, roles }) => {
  useSipContext()
  const columns: ColumnDef<User>[] = tableCol({
    showActions: true,
    columns: [
      {
        accessorKey: "firstname",
        id: 'firstname',
        header: "Full Name",
        cell: ({ row }) => (
          <div className="capitalize">
            {row.original?.firstname + " " + row.original?.lastname}
          </div>
        ),
      },
      {
        accessorKey: "email",
        id: 'email',
        header: "Email",
        cell: ({ row }) => <div>{row.original?.email}</div>,
      },
      {
        accessorKey: "user_role",
        id: 'user_role',
        header: "Role",
        cell: ({ row }) => <div>{row.original?.user_role}</div>,
      },
      ...(costumCols?.map((col: any, index: number) => ({
      id: col.id ?? `custom-${index}`, // Fallback to unique id
      ...col
    })) || []),
    ],
    EditComponent: UserEdit,
    resource: "users",
    responseMessage: (user: User) => `User ${user.firstname} ${user.lastname} removed`
  });

  return (
    <CommonList>
      <CommonTableList
        columns={columns}
        filterSearch="email"
        create={<UserCreate prop={roles} />}
      />
    </CommonList>
  );
};

export default UsersList;
